const config = {
	apiUrl: 'https://api.imopvocacional.com'
};

export default config;
